import LFO from './lfo';
import Utils from './utils';




export default class VectorTools {


	constructor(args) {
		this.display = args.display;
		this.lfoPointer = 0;
		let fMin = 7;
		let fMax = 9;
		let numLFOs = 73;
		this.lfos = [];
		while(--numLFOs >= 0) {
			this.lfos.push(new LFO(Utils.randomFloat(fMin,fMax), 1, Math.random()*Math.PI*2));
		}
	}

	static get() {
		return window._VECTORS; // half-assed singleton, has to be instantiated in System before use
	}

	update(delta) {
		this.lfoPointer = 0;
		for(let lfo of this.lfos) lfo.update(delta);
	}

	offset(num, scale) {
		this.lfoPointer++;
		this.lfoPointer %= this.lfos.length;
		return num + (this.lfos[this.lfoPointer].value * scale);
	}

	getSetting(name) {
		return this.display.settings[name];
	}

	generatePathsFromShape(args) {
		// handle multi-path shapes
		let paths = [];
		let cursorX = 0, cursorY = 0;
		let charX = args.charX || 0;
		let charY = args.charY || 0;
		let minX = 1000000, maxX = -1000000, minY = 1000000, maxY = -1000000;
		for(let p of args.shape) {
			// parse and store string path coords in vertex pairs
			// '50 0 100 0 100 50 150 50 150 100 100 100 100 150 50 150 50 100 0 100 0 50 50 50'
			let verts = [];
			let c = p.split(' ');
			for(let i=0; i<c.length; i++) {
				if(c[i] == 'X') {
					// text: new char
					cursorX += charX;
					continue;
				}
				if(c[i] == 'Y') {
					// text: new line
					cursorX = 0;
					cursorY += charY;
					continue;
				}
				if(i%2 == 0) {
					// even = x
					let x = parseFloat(c[i])+cursorX;
					verts.push([x]);
					// find bounds
					if(x < minX) minX = x;
					if(x > maxX) maxX = x;
				} else {
					// odd = y
					let y = parseFloat(c[i])+cursorY;
					verts[verts.length-1].push(y);
					// find bounds
					if(y < minY) minY = y;
					if(y > maxY) maxY = y;
				}
			}
			if(verts.length > 0) paths.push(verts);
		}
		// offset all vertex pairs such that 0,0 is the center of the shape's boundary
		let width = maxX - minX;
		let height = maxY - minY;
		let xo = minX + (width/2);
		let yo = minY + (height/2);
		// x align ?
		if(args.align == 'left') xo = 0;
		if(args.align == 'right') xo *= 2;
		for(let p of paths) {
			p.forEach(c => {
				c[0] -= xo;
				c[1] -= yo;
			});
		}
		// visual bounding box?
		if(args.border > 0) {
			let wh = width/2;
			let hh = height/2;
			xo = 0;
			if(args.align == 'left') xo = wh;
			if(args.align == 'right') xo = -wh;
			paths.push([
				[-wh-args.border+xo, -hh-args.border],
				[wh+args.border+xo, -hh-args.border],
				[wh+args.border+xo, hh+args.border],
				[-wh-args.border+xo, hh+args.border],
				[-wh-args.border+xo, -hh-args.border]
			]);
		}
		return paths;
	}

	updateTextPaths(string, entity) {
		// entity.sprite.paths = VectorTools.get().generatePathsFromShape({
		let vt = VectorTools.get();
		entity.sprite.paths = vt.generatePathsFromShape({
			shape: entity.system.factory.textGen.getTextPaths(string.toUpperCase()),
			charX: entity.system.factory.textGen.font.charX,
			charY: entity.system.factory.textGen.font.charY,
			align: entity.sprite._args.align || false,
			border: entity.sprite._args.border || 0,
		});
	}

}